import { ChevronDown } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { Button } from "../ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "../ui/dropdown-menu";
import { RuleFormData, RuleTypeOption } from "./builderSchema";

interface RuleTypeSelectorProps {
    ruleTypeOptions: RuleTypeOption[];
}

export default function RuleTypeSelector({ ruleTypeOptions }: RuleTypeSelectorProps) {
    const { watch, setValue } = useFormContext<RuleFormData>();
    const ruleType = watch("ruleType");

    return (
        <div className="space-y-2 ml-2">
            <label className="font-medium block text-gray-700">Rule Type</label>

            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="outline"
                        className="flex items-center justify-between w-full sm:w-1/2"
                    >
                        {ruleType.label || "Select a rule type"}
                        <ChevronDown className="h-4 w-4 ml-2 opacity-70" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-full sm:w-1/2">
                    <DropdownMenuLabel>Select Rule Type</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    {ruleTypeOptions.map((opt) => (
                        <DropdownMenuItem
                            key={opt.value}
                            className="w-[750px]"
                            onClick={() => setValue("ruleType", opt)}
                        >
                            {opt.label}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}